import { cn } from '../../lib/utils';

export const segmentBaseClassName =
    'inline-flex h-9 shrink-0 items-center gap-2 whitespace-nowrap rounded-lg border px-3 text-sm font-semibold tabular-nums text-neutral-950 transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary-500 [&_svg]:size-4 [&_svg]:shrink-0';

export function segmentClassName(selected: boolean) {
    return cn(
        segmentBaseClassName,
        selected
            ? 'border-neutral-400 bg-white shadow-sm'
            : 'border-transparent hover:bg-neutral-300/45 active:bg-neutral-300/70',
    );
}

export const segmentedTrackClassName = 'admin-tab-switcher-track';
export const segmentedTabListClassName =
    'admin-tab-switcher-track max-sm:grid max-sm:w-full max-sm:grid-cols-2 max-sm:gap-1';
export const segmentedTabPhoneClassName =
    'max-sm:h-auto max-sm:min-h-9 max-sm:w-full max-sm:min-w-0 max-sm:justify-start max-sm:whitespace-normal max-sm:py-1.5 max-sm:text-left';
